





























































































































import { PrayBoards } from '@/models/CeremonyFormModel';
import Vue from 'vue';

export default Vue.extend({
  props: {
    checkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      prayFor: [
        new PrayBoards('', '', '', ''),
      ],
      informMethod: '',
      targetSelection: [
        '冤親債主',
        '歷代祖先',
        '累世父母師長',
        '未出生子女',
        '誤殺誤傷之眾生',
        '境內一切眾生(地基主)',
        // '其他',
      ],
    };
  },
  computed: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.prayFor = this.$store.state.form.ceremonyForm.prayBoards;
    },
    clearData() {
      this.$notify({
        type: 'info',
        title: '已清空資料',
      });
      this.prayFor = [
        new PrayBoards('', '', '', ''),
      ];
      this.$store.commit('updatePrayFor', this.prayFor);
    },
    deletePerson(key: number) {
      this.prayFor.splice(key, 1);
    },
    addPerson() {
      this.prayFor.push(new PrayBoards('', '', '', ''));
    },
    goStep(move: string) {
      if (move === 'last') {
        this.$router.push('longevity');
      }
      if (move === 'next') {
        this.$router.push('attendInfo');
      }
    },
  },
});
